import { put, takeLatest, call } from "redux-saga/effects"
import * as actionTypes from "./actionTypes"
import * as actions from "./actions"
import { db } from "helpers/firebase/firebaseConfig"
import { collection, getDocs, updateDoc, doc, getDoc } from "firebase/firestore"

async function fetchClientsApi() {
  try {
    const querySnapshot = await getDocs(collection(db, "app_users"))
    const clients = querySnapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    }))
    return clients
  } catch (error) {
    throw error
  }
}

async function updateClientStatusApi(clientId, newStatus) {
  try {
    const clientRef = doc(db, "app_users", clientId)
    await updateDoc(clientRef, {
      account_status: newStatus
    })
    
    // Return the updated client data by fetching it again
    const updatedClient = await getDoc(clientRef)
    return { id: updatedClient.id, ...updatedClient.data() }
  } catch (error) {
    throw error
  }
}

// Worker Saga for fetching clients
function* fetchClients() {
  try {
    const clients = yield call(fetchClientsApi)
    yield put({ type: actionTypes.FETCH_CLIENTS_SUCCESS, payload: clients })
  } catch (error) {
    yield put({ type: actionTypes.FETCH_CLIENTS_FAILURE, payload: error })
  }
}

// Worker Saga for updating client status
function* updateClientStatus(action) {
  const { clientId, newStatus } = action.payload
  try {
    yield call(updateClientStatusApi, clientId, newStatus)
    // Option 1: Refetch all clients (as in original code)
    const clients = yield call(fetchClientsApi)
    yield put({ type: actionTypes.FETCH_CLIENTS_SUCCESS, payload: clients })
    
    // Option 2: Just update the single client in state (more efficient)
    // yield put(actions.updateClientStatusSuccess(clientId, newStatus))
  } catch (error) {
    yield put(actions.updateClientStatusFailure(error))
  }
}

export function* clientSaga() {
  yield takeLatest(actionTypes.FETCH_CLIENTS_REQUEST, fetchClients)
  yield takeLatest(actionTypes.UPDATE_CLIENT_STATUS_REQUEST, updateClientStatus)
}

export default clientSaga